import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-unauthorized-error',
    templateUrl: './unauthorized-error.component.html',
    styleUrls: ['./unauthorized-error.component.scss'],
})
export class UnauthorizedErrorComponent implements OnInit{
    constructor(private route: ActivatedRoute) {
    }

    ngOnInit() {
        const url = this.route.snapshot.paramMap.get('url');
    }
}
